module.exports = __webpack_public_path__ + "static/media/teygja_aftanverdlaeri_small.40d3aad0.png";